import React from "react"
import { withRouter } from "react-router-dom"
import "./AcceptSuggestionButton.scss"
import { ACCEPT_BUTTON } from "../../../constants/messages"
import { LikeFilled } from "@ant-design/icons"
import { Button } from "../../../atoms"
import { ActivityIndicator } from "../../ActivityIndicator"

const AcceptSuggestionButton = (props) => {
  const clickHandler = async () => {
    props.setSuggestion(true)
    await props.accepted()
    props.setSuggestion(false)
  }
  return (
    <div id="AcceptSuggestionButton">
      <Button onClick={clickHandler} disabled={props.suggesting}>
        {props.suggesting && <ActivityIndicator />}
        {ACCEPT_BUTTON} <LikeFilled />
      </Button>
    </div>
  )
}

export default withRouter(AcceptSuggestionButton)
